import type { UserRole } from '../types/gateway';
import { QUICK_ACTIONS } from '../types/foreman';
import styles from './QuickActions.module.css';

interface QuickActionsProps {
  role: UserRole;
  onSelect: (prompt: string) => void;
}

export function QuickActions({ role, onSelect }: QuickActionsProps) {
  const actions = QUICK_ACTIONS[role] || [];

  return (
    <div className={styles.quickActions}>
      {actions.map((action) => (
        <button
          key={action.label}
          className={styles.chip}
          onClick={() => onSelect(action.prompt)}
        >
          <span className={styles.chipIcon}>{action.icon}</span>
          <span className={styles.chipLabel}>{action.label}</span>
        </button>
      ))}
    </div>
  );
}
